// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'vue-awesome/icons/user-alt'
import 'vue-awesome/icons/bars'
import 'vue-awesome/icons/user-circle'
import 'vue-awesome/icons/exclamation'
import Vue from 'vue'
import Root from './Root'
import router from './router'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './axios/index'
import echarts from 'echarts'
import store from './vuex/store'
import Icon from 'vue-awesome/components/Icon'
import './styles/index.scss'

Vue.component('icon', Icon)

Vue.use(elementUI)
Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { Root },
  template: '<Root/>',
  data () {
    return {
      mFlag: null,
      isFill: false
    }
  },
  created () {
    // this.mFlag = this._isMobile()
    if (!this.checkDeviceType().isPc && !this.checkDeviceType().isTablet) {
      this.mFlag = true
    } else {
      this.mFlag = false
    }
    // 页面跳转时返回页面顶部
    router.afterEach((to, from, next) => {
      window.scrollTo(0, 0)
    })
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    checkDeviceType () {
      // 判断当前设备信息手机端或是PC端
      let ua = navigator.userAgent
      let isWindowsPhone = /(?:Windows Phone)/.test(ua)
      let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
      let isAndroid = /(?:Android)/.test(ua)
      let isFireFox = /(?:Firefox)/.test(ua)
      // let isChrome = /(?:Chrome|CriOS)/.test(ua)
      let isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
      let isPhone = /(?:iPhone)/.test(ua) && !isTablet
      let isPc = !isPhone && !isAndroid && !isSymbian
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js